import { ButtonPrimary } from "components/Atoms/Button";
import React, { useCallback, useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader, useOpenPreviewPanel } from "../PreviewPanel";
import { VenuePreviewPanelContent } from "./VenuePreviewPanelContent";

interface VenuePreviewPanelProps {
  companyId: number
}

const VenuePreviewPanel = (props: VenuePreviewPanelProps) => {
  const { companyId } = props;

  const api = useApi(() => window.CoreApi.Venue.GetVenue(companyId), ["venue", companyId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [companyId]);

  if (api.isInitialLoading) {
    return <>
      <PreviewPanelHeader title={site.currentEnvironment.functionGroups.venue.singular} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const venueDetails = api.data.details;
  const company = api.data.company;

  return <>
    <PreviewPanelHeader title={site.currentEnvironment.functionGroups.venue.singular} />
    <VenuePreviewPanelContent
      company={company}
      venueDetails={venueDetails}

      onChange={async () => {
        await api.refetch()
      }}
    />
    <PreviewPanelFooter>
      <ButtonPrimary href={routes.company_Detail(companyId).absolute} label={RESX.Buttons.DetailView} />
    </PreviewPanelFooter>
  </>;
};

export interface VenuePreviewProps {
  venueId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
  onOpen?: () => void
}

export const VenuePreview = (props: VenuePreviewProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    onOpen={props.onOpen}
    trigger={props.trigger}
    size="medium"
    id={`venue-preview-${props.venueId}`}
  >
    <VenuePreviewPanel
      companyId={props.venueId}
    />
  </PreviewPanel>;
};

export const useOpenVenuePreviewPanel = () => {
  const openPreviewPanel = useOpenPreviewPanel();

  const openVenuePreviewPanel = useCallback((venueId: number) => {
    openPreviewPanel(<VenuePreviewPanel
      companyId={venueId}
    />, `venue-preview-${venueId}`);
  }, []);

  return openVenuePreviewPanel;
}